import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelect = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#000000",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	"data-iconid": 347845,
	"data-svgname": "Single select",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M7.854 10.854l3.792 3.792a.5.5 0 00.708 0l3.793-3.792a.5.5 0 00-.354-.854H8.207a.5.5 0 00-.353.854z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0120.25 22H3.75A1.75 1.75 0 012 20.25V3.75zm1.75-.25a.25.25 0 00-.25.25v16.5c0 .138.112.25.25.25h16.5a.25.25 0 00.25-.25V3.75a.25.25 0 00-.25-.25H3.75z"
	})]
});
export default SvgSelect;
